import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideo: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="video, camera, movie, play"><path fillRule="evenodd" clipRule="evenodd" d="M2 7.75C2 5.67893 3.67893 4 5.75 4H12.25C14.3211 4 16 5.67893 16 7.75V8.78691L19.4674 7.05322C20.631 6.47143 22 7.31755 22 8.61847V15.3824C22 16.6833 20.631 17.5294 19.4674 16.9476L16 15.214V16.25C16 18.3211 14.3211 20 12.25 20H5.75C3.67893 20 2 18.3211 2 16.25V7.75ZM16 13.5369L20.1382 15.606C20.3044 15.6891 20.5 15.5682 20.5 15.3824V8.61847C20.5 8.43262 20.3044 8.31175 20.1382 8.39486L16 10.464V13.5369Z" fill="currentColor"/></CentralIconBase>;
};

export default IconVideo;
